import { render, staticRenderFns } from "./CollectionGridScreen.vue?vue&type=template&id=bc6e9d2c&scoped=true&"
import script from "./CollectionGridScreen.vue?vue&type=script&lang=js&"
export * from "./CollectionGridScreen.vue?vue&type=script&lang=js&"
import style0 from "./CollectionGridScreen.vue?vue&type=style&index=0&id=bc6e9d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6e9d2c",
  null
  
)

export default component.exports